export default {
    seo: {
        title: '',
        description: ''
    },
    title: 'Блог и новости',
    shortTitle: 'Блог',
    socialTitle: "Читайте нас на других площадках:",
    readMore: 'Читать полностью на '
}
